import dynamic from 'next/dynamic';

const HomeLayout = dynamic(() => import(`../src/components/layouts/Home`));

const Home = () => <HomeLayout />;

export default Home;
